module.exports = __webpack_public_path__ + "img/home_icon_keji_normal.72d6f3f0.png";